import { combineReducers } from 'redux';

import {
  getArticleCommentListRequest,
  getArticleCommentListSuccess,
  getArticleCommentListFail,
} from '../actions';
import { ArticleCommentAction } from '../types';
import { Article } from '../../../../types/items';
import { ItemList } from '../../../../types/main';
import { Loadable, Reducer } from '../../../types';
import { stripItems } from '../../../../utility/store';

export type ArticleCommentListState = Loadable<ItemList<Article>>;
type ReducerOf<T extends keyof ArticleCommentListState> = Reducer<ArticleCommentListState, ArticleCommentAction, T>;


const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getArticleCommentListRequest.type:
      return state ? stripItems(state) : null;

    case getArticleCommentListSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getArticleCommentListRequest.type:
      return true;

    case getArticleCommentListSuccess.type:
    case getArticleCommentListFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<ArticleCommentListState>({
  data,
  loading,
});
